
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import ZohoCRMScript from "../../ZohoCRMScript";

const FinalCTASection = () => {
  return (
    <>
      <ZohoCRMScript />
      <section className="py-24 bg-gradient-to-br from-[#8932c8] via-[#7a2cb3] to-[#b87ade] relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-20 w-32 h-32 bg-white rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-20 w-48 h-48 bg-white rounded-full blur-3xl"></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-64 h-64 bg-white rounded-full blur-3xl"></div>
      </div>
      
      <div className="container mx-auto px-4 md:px-6 text-center relative z-10">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-4xl md:text-6xl font-bold text-white mb-8 leading-tight">
            Your AI-Native 
            <span className="block bg-gradient-to-r from-white to-gray-200 bg-clip-text text-transparent">
              MSSP Engine
            </span>
          </h2>
          
          <div className="space-y-6 mb-12">
            <p className="text-2xl text-white/95 font-medium">
              Spharaka XDR™ with AuraXP™ enabled is more than a platform - it's your AI-native MSSP engine.
            </p>
            <p className="text-xl text-white/80 max-w-4xl mx-auto leading-relaxed">
              Ready to evolve from playbooks to true AI-powered partnership? Let's build your next-gen security service together.
            </p>
          </div>
          
          <div className="flex flex-col sm:flex-row gap-6 justify-center items-center">
            <Dialog>
              <DialogTrigger asChild>
                <Button 
                  size="cta"
                  className="bg-white text-[#8932c8] hover:bg-gray-100 hover:scale-105 transition-all duration-300 shadow-2xl rounded-2xl"
                >
                  Partner with Us
                </Button>
              </DialogTrigger>
              <DialogContent className="sm:max-w-2xl max-h-[90vh] overflow-y-auto">
                <DialogHeader>
                  <DialogTitle>Partner with Us</DialogTitle>
                </DialogHeader>
                <div id='crmWebToEntityForm2' className='zcwf_lblTopBottom crmWebToEntityForm' style={{backgroundColor: 'white', color: 'black', maxWidth: '600px', padding: '25px', margin: '0 auto', boxSizing: 'border-box'}}>
                  <form id='webform966770000000627838' action='https://crm.zoho.in/crm/WebToLeadForm' name='WebToLeads966770000000627838' method='POST' onSubmit={() => { return (window as any).checkMandatory966770000000627838(); }} acceptCharset='UTF-8'>
                    <input type='text' style={{display:'none'}} name='xnQsjsdp' value='b4852772ee4fc15953fda75d288e2eaa12d3e5474a40df629a232d4dd98f0931' />
                    <input type='hidden' name='zc_gad' id='zc_gad2' value='' />
                    <input type='text' style={{display:'none'}} name='xmIwtLD' value='44138232174f2b196b594ff4cce867d47e8236f2466fac39baca8c716d84ad896ecd0f283ac1d78bbe30c472909e7edc' />
                    <input type='text' style={{display:'none'}} name='actionType' value='TGVhZHM=' />
                    <input type='text' style={{display:'none'}} name='returnURL' value='null' />
                    
                    <div className='text-xl font-semibold mb-6 text-center' style={{color: 'black', fontFamily:'Arial'}}>Partners</div>
                    
                    <div className='mb-4'>
                      <div className='mb-2' style={{fontSize:'14px', fontFamily: 'Arial', fontWeight: '500'}}>
                        <label htmlFor='First_Name2'>First Name <span style={{color:'red'}}>*</span></label>
                      </div>
                      <div>
                        <input 
                          type='text' 
                          id='First_Name2' 
                          aria-required='true' 
                          aria-label='First Name' 
                          name='First Name' 
                          maxLength={40}
                          className='w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#8932c8] focus:border-transparent'
                        />
                      </div>
                    </div>
                    
                    <div className='mb-4'>
                      <div className='mb-2' style={{fontSize:'14px', fontFamily: 'Arial', fontWeight: '500'}}>
                        <label htmlFor='Last_Name2'>Last Name <span style={{color:'red'}}>*</span></label>
                      </div>
                      <div>
                        <input 
                          type='text' 
                          id='Last_Name2' 
                          aria-required='true' 
                          aria-label='Last Name' 
                          name='Last Name' 
                          maxLength={80}
                          className='w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#8932c8] focus:border-transparent'
                        />
                      </div>
                    </div>
                    
                    <div className='mb-4'>
                      <div className='mb-2' style={{fontSize:'14px', fontFamily: 'Arial', fontWeight: '500'}}>
                        <label htmlFor='Designation2'>Title <span style={{color:'red'}}>*</span></label>
                      </div>
                      <div>
                        <input 
                          type='text' 
                          id='Designation2' 
                          aria-required='true' 
                          aria-label='Designation' 
                          name='Designation' 
                          maxLength={100}
                          className='w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#8932c8] focus:border-transparent'
                        />
                      </div>
                    </div>
                    
                    <div className='mb-4'>
                      <div className='mb-2' style={{fontSize:'14px', fontFamily: 'Arial', fontWeight: '500'}}>
                        <label htmlFor='Email2'>Email <span style={{color:'red'}}>*</span></label>
                      </div>
                      <div>
                        <input 
                          type='text' 
                          data-ftype='email' 
                          autoComplete='false' 
                          id='Email2' 
                          aria-required='true' 
                          aria-label='Email' 
                          name='Email' 
                          maxLength={100}
                          className='w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#8932c8] focus:border-transparent'
                        />
                      </div>
                    </div>
                    
                    <div className='mb-4'>
                      <div className='mb-2' style={{fontSize:'14px', fontFamily: 'Arial', fontWeight: '500'}}>
                        <label htmlFor='Phone2'>Phone <span style={{color:'red'}}>*</span></label>
                      </div>
                      <div>
                        <input 
                          type='text' 
                          id='Phone2' 
                          aria-required='true' 
                          aria-label='Phone' 
                          name='Phone' 
                          maxLength={30}
                          className='w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#8932c8] focus:border-transparent'
                        />
                      </div>
                    </div>
                    
                    <div className='mb-4'>
                      <div className='mb-2' style={{fontSize:'14px', fontFamily: 'Arial', fontWeight: '500'}}>
                        <label htmlFor='Company2'>Company <span style={{color:'red'}}>*</span></label>
                      </div>
                      <div>
                        <input 
                          type='text' 
                          id='Company2' 
                          aria-required='true' 
                          aria-label='Company' 
                          name='Company' 
                          maxLength={200}
                          className='w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#8932c8] focus:border-transparent'
                        />
                      </div>
                    </div>
                    
                    <div className='mb-4'>
                      <div className='mb-2' style={{fontSize:'14px', fontFamily: 'Arial', fontWeight: '500'}}>
                        <label htmlFor='Industry2'>Industry <span style={{color:'red'}}>*</span></label>
                      </div>
                      <div>
                        <select 
                          id='Industry2' 
                          onChange={(e) => { (window as any).addAriaSelected966770000000627838?.(); }} 
                          aria-required='true' 
                          aria-label='Industry' 
                          name='Industry'
                          className='w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#8932c8] focus:border-transparent bg-white'
                        >
                          <option value='-None-'>-None-</option>
                          <option value='Managed Security Service Providers (MSSPs)'>Managed Security Service Providers (MSSPs)</option>
                          <option value='Systems Integrator (SIs)'>Systems Integrator (SIs)</option>
                          <option value='IT Consulting Firms'>IT Consulting Firms</option>
                          <option value='Value-Added Resellers (VARs)'>Value-Added Resellers (VARs)</option>
                          <option value='Distributors'>Distributors</option>
                        </select>
                      </div>
                    </div>
                    
                    <div className='mb-4'>
                      <div className='mb-2' style={{fontSize:'14px', fontFamily: 'Arial', fontWeight: '500'}}>
                        <label htmlFor='City2'>City <span style={{color:'red'}}>*</span></label>
                      </div>
                      <div>
                        <input 
                          type='text' 
                          id='City2' 
                          aria-required='true' 
                          aria-label='City' 
                          name='City' 
                          maxLength={100}
                          className='w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#8932c8] focus:border-transparent'
                        />
                      </div>
                    </div>
                    
                    <div className='mb-4'>
                      <div className='mb-2' style={{fontSize:'14px', fontFamily: 'Arial', fontWeight: '500'}}>
                        <label htmlFor='Zip_Code2'>Zip Code <span style={{color:'red'}}>*</span></label>
                      </div>
                      <div>
                        <input 
                          type='text' 
                          id='Zip_Code2' 
                          aria-required='true' 
                          aria-label='Zip Code' 
                          name='Zip Code' 
                          maxLength={30}
                          className='w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#8932c8] focus:border-transparent'
                        />
                      </div>
                    </div>
                    
                    <div className='mb-4'>
                      <div className='mb-2' style={{fontSize:'14px', fontFamily: 'Arial', fontWeight: '500'}}>
                        <label htmlFor='Country2'>Country <span style={{color:'red'}}>*</span></label>
                      </div>
                      <div>
                        <input 
                          type='text' 
                          id='Country2' 
                          aria-required='true' 
                          aria-label='Country' 
                          name='Country' 
                          maxLength={100}
                          className='w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#8932c8] focus:border-transparent'
                        />
                      </div>
                    </div>
                    
                    <div className='mb-6'>
                      <div className='flex items-start'>
                        <input 
                          autoComplete='off' 
                          id='privacyTool966770000000627838' 
                          type='checkbox' 
                          aria-checked='false' 
                          name='' 
                          aria-errormessage='privacyErr966770000000627838' 
                          aria-label='privacyTool' 
                          onClick={(e) => { (window as any).disableErr966770000000627838?.(); }}
                          className='mt-1 mr-3'
                        />
                        <div className='text-sm text-gray-600'>
                          <a href='http://spharaka.com/privacy-policy' title='http://spharaka.com/privacy-policy' target='_blank' className='text-[#8932c8] hover:underline'>
                            I agree to the Privacy Policy and consent to the processing of my personal data
                          </a>
                        </div>
                      </div>
                      <div id='privacyErr966770000000627838' aria-live='polite' style={{fontSize:'12px', color:'red', paddingLeft: '5px', visibility:'hidden'}}>Please accept this</div>
                    </div>
                    
                    <input type='text' style={{display: 'none'}} name='aG9uZXlwb3Q' value='' />
                    
                    <div className='flex gap-3'>
                      <input 
                        type='submit' 
                        id='formsubmit2' 
                        role='button' 
                        className='bg-[#8932c8] hover:bg-[#7a2cb3] text-white px-6 py-2 rounded-md cursor-pointer transition-colors' 
                        value='Submit' 
                        aria-label='Submit' 
                        title='Submit'
                      />
                      <input 
                        type='reset' 
                        role='button' 
                        name='reset' 
                        value='Reset' 
                        aria-label='Reset' 
                        title='Reset'
                        className='border border-gray-300 bg-white text-gray-700 px-6 py-2 rounded-md cursor-pointer hover:bg-gray-50 transition-colors'
                      />
                    </div>
                  </form>
                </div>
              </DialogContent>
            </Dialog>
            
            <Dialog>
              <DialogTrigger asChild>
                <Button 
                  variant="outline"
                  size="cta"
                  className="border-2 border-white text-white hover:bg-white hover:text-[#8932c8] hover:scale-105 transition-all duration-300 bg-transparent backdrop-blur-sm rounded-2xl"
                >
                  Schedule Consultation
                </Button>
              </DialogTrigger>
              <DialogContent className="sm:max-w-2xl max-h-[90vh] overflow-y-auto">
                <DialogHeader>
                  <DialogTitle>Schedule Consultation</DialogTitle>
                </DialogHeader>
                <div id='crmWebToEntityForm2' className='zcwf_lblLeft crmWebToEntityForm' style={{backgroundColor: 'white', color: 'black', maxWidth: '600px'}}>
                  <form id='webform966770000000572002' action='https://crm.zoho.in/crm/WebToLeadForm' name='WebToLeads966770000000572002' method='POST' onSubmit={() => { return (window as any).checkMandatory966770000000572001(); }} acceptCharset='UTF-8'>
                    <input type='text' style={{display:'none'}} name='xnQsjsdp' value='2eaa648798ce23a7a9a9fdfb797621a05074c8311ce9031824d1b4d79807096f' />
                    <input type='hidden' name='zc_gad' id='zc_gad' value='' />
                    <input type='text' style={{display:'none'}} name='xmIwtLD' value='3b367f412ccfde6c347aca9059e7efedf4cd6eef72f9a51d2beb75a4850be285503386a2c820cee984c68e0e4df8b7e1' />
                    <input type='text' style={{display:'none'}} name='actionType' value='TGVhZHM=' />
                    <input type='text' style={{display:'none'}} name='returnURL' value='null' />
                    
                    <div className='zcwf_row'>
                      <div className='zcwf_col_lab' style={{fontSize:'12px', fontFamily: 'Arial'}}>
                        <label htmlFor='First_Name2'>First Name <span style={{color:'red'}}>*</span></label>
                      </div>
                      <div className='zcwf_col_fld'>
                        <input type='text' id='First_Name2' aria-required='true' aria-label='First Name' name='First Name' maxLength={40} />
                      </div>
                    </div>
                    
                    <div className='zcwf_row'>
                      <div className='zcwf_col_lab' style={{fontSize:'12px', fontFamily: 'Arial'}}>
                        <label htmlFor='Last_Name2'>Last Name <span style={{color:'red'}}>*</span></label>
                      </div>
                      <div className='zcwf_col_fld'>
                        <input type='text' id='Last_Name2' aria-required='true' aria-label='Last Name' name='Last Name' maxLength={80} />
                      </div>
                    </div>
                    
                    <div className='zcwf_row'>
                      <div className='zcwf_col_lab' style={{fontSize:'12px', fontFamily: 'Arial'}}>
                        <label htmlFor='Email2'>Work Email <span style={{color:'red'}}>*</span></label>
                      </div>
                      <div className='zcwf_col_fld'>
                        <input type='text' data-ftype='email' autoComplete='false' id='Email2' aria-required='true' aria-label='Email' name='Email' maxLength={100} />
                      </div>
                    </div>
                    
                    <div className='zcwf_row'>
                      <div className='zcwf_col_lab' style={{fontSize:'12px', fontFamily: 'Arial'}}>
                        <label htmlFor='Company2'>Company <span style={{color:'red'}}>*</span></label>
                      </div>
                      <div className='zcwf_col_fld'>
                        <input type='text' id='Company2' aria-required='true' aria-label='Company' name='Company' maxLength={200} />
                      </div>
                    </div>
                    
                    <div className='zcwf_row'>
                      <div className='zcwf_col_lab' style={{fontSize:'12px', fontFamily: 'Arial'}}>
                        <label htmlFor='Description2'>How can we help? <span style={{color:'red'}}>*</span></label>
                      </div>
                      <div className='zcwf_col_fld'>
                        <textarea style={{fontFamily: 'Arial, sans-serif'}} id='Description2' aria-required='true' aria-label='Description' name='Description'></textarea>
                      </div>
                    </div>
                    
                    <div className='zcwf_row'>
                      <div className='zcwf_col_lab'></div>
                      <div className='zcwf_col_fld'>
                        <div style={{display: 'flex', alignItems: 'flex-start', marginBottom: '10px'}}>
                          <input type='checkbox' id='privacyConsent2' required style={{marginRight: '8px', marginTop: '2px'}} />
                          <label htmlFor='privacyConsent2' style={{fontSize: '12px', color: '#666', lineHeight: '1.4'}}>
                            I agree to the{" "}
                            <a href='/privacy-policy' target='_blank' style={{color: '#8932c8', textDecoration: 'underline'}}>
                              Privacy Policy
                            </a>{" "}
                            and consent to the processing of my personal data. <span style={{color: 'red'}}>*</span>
                          </label>
                        </div>
                      </div>
                    </div>
                    
                    <input type='text' style={{display: 'none'}} name='aG9uZXlwb3Q' value='' />
                    
                    <div className='zcwf_row'>
                      <div className='zcwf_col_lab'></div>
                      <div className='zcwf_col_fld'>
                        <input type='submit' id='formsubmit' className='formsubmit zcwf_button' value='Submit' style={{backgroundColor: '#8932c8', color: 'white', border: 'none', padding: '10px 20px', borderRadius: '4px', cursor: 'pointer'}} />
                        <input type='reset' className='zcwf_button' name='reset' value='Reset' style={{marginLeft: '10px', padding: '10px 20px', borderRadius: '4px', cursor: 'pointer'}} />
                      </div>
                    </div>
                  </form>
                </div>
              </DialogContent>
            </Dialog>
          </div>
          
          <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8 text-white/80">
            <div className="text-center">
              <div className="text-3xl font-bold mb-2">95%</div>
              <div className="text-lg">Operational Efficiency Gain</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold mb-2">80%</div>
              <div className="text-lg">Reduction in False Positives</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold mb-2">24/7</div>
              <div className="text-lg">AI-Powered Protection</div>
            </div>
          </div>
        </div>
      </div>
    </section>
    </>
  );
};

export default FinalCTASection;
